import React from 'react';

import { BaseInput } from '../BaseInput';
import { useStringInputController } from './index.controller';
import { StringInputProps } from './index.types';

export function StringInputView(props: StringInputProps) {
  const { baseInputProps } = useStringInputController(props);

  return <BaseInput {...baseInputProps} />;
}
